import React,{useState,useEffect}  from 'react'
import {Box,Typography,Container,Grid,Paper,Button,TextField} from '@mui/material'
import { MicRounded,FormatAlignCenter } from '@mui/icons-material';
import InputAdornment from '@mui/material/InputAdornment';


const EditorText = ({data,setData,width,title,label,isRequired,maxRow,minRow})=>{
	return(
		<Box width={width}>
			<Typography sx={{color:"#fff",fontSize:12,fontFamily:"dinofans",mb:2,mt:1}}>{title}</Typography>
            <TextField
                label={label}
                onChange={(e)=>{setData(e?.target?.value)}}
                type='text'
                placeholder={`${label}...`}
                multiline
                required={isRequired ? isRequired : false}
                style={{width:width}}
                value={data}
                minRows={minRow ? minRow : 10}
                maxRows={maxRow ? maxRow : 15}
                InputProps={{
                    endAdornment: (
                    <InputAdornment  style={{justifyContent:"center",padding:5}} position="end">
                        <FormatAlignCenter fontSize='small' sx={{color:"#fff"}}/>
                    </InputAdornment>
                    )
                }}
            />	
		</Box>
	)
}

export default EditorText